import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackArrow from '../assets/images/backarrow.svg';
const Header = ({ title }) => {
  const navigate = useNavigate(); // React Router's hook to navigate

  const handleBack = () => {
    navigate(-1); // Goes back to the previous page
  };

  return (
    <div className="header-nav">
      <div className="header_content" onClick={handleBack}>
        <img src={BackArrow} alt="Back" />
        <span>
          <h1>Back</h1>
        </span>        
      </div>
      <div style={{paddingLeft:"80px"}}><h1>{title}</h1></div>
    </div>
  );
};

export default Header;
